import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Tooltip,
  InputAdornment,
} from "@material-ui/core";
import jsPDF from "jspdf";
import InterFont from "../fonts/Inter.ttf";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { Toolbar, AppBar } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import loanSolvLogo from "../images/logo/LoanSolveLogo.png";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Cropper from "react-easy-crop";
import axios from "axios";
import { toast } from "react-toastify";
import Notification from "../components/Notification";
import useStyles from "../themes/style";
import { useHistory, useLocation } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import red from "@material-ui/core/colors/red";
import "react-toastify/dist/ReactToastify.css";
import getCroppedImg from "../utils/croppedImage";
import { jwtDecode } from "jwt-decode";
import "../css/agreement-resume.css";
import moment from "moment";
import { BsCurrencyRupee } from "react-icons/bs";

const positions = [toast.POSITION.TOP_RIGHT];

const SalaryTable = ({ signData, salaryBreakupData }) => {
  const headerStyle = {
    border: "1px solid #000",
    padding: "8px",
    fontWeight: "bold",
    textAlign: "left",
  };

  const cellStyle = {
    border: "1px solid #000",
    padding: "8px",
    textAlign: "left",
  };

  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontFamily: "Arial, sans-serif",
        marginTop: "20px",
      }}
    >
      <thead>
        <tr>
          <th colSpan="2" style={headerStyle}>
            Name: {signData.employeeName}
          </th>
          <th colSpan="2" style={headerStyle}>
            Date: {moment(signData.offerDate).format("Do MMMM YY")}
          </th>
        </tr>
        <tr>
          <th colSpan="4" style={headerStyle}>
            Designation: {signData.designation}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={headerStyle}></td>
          <td style={headerStyle}>Per month (INR)</td>
          <td style={headerStyle}>Per annum (INR)</td>
        </tr>
        <tr>
          <td style={cellStyle}>Basic</td>
          <td style={cellStyle}>{salaryBreakupData.basic}</td>
          <td style={cellStyle}>{salaryBreakupData.basic * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>HRA</td>
          <td style={cellStyle}>{salaryBreakupData.hra}</td>
          <td style={cellStyle}>{salaryBreakupData.hra * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>Other Allowance</td>
          <td style={cellStyle}>{salaryBreakupData.otherAllowance}</td>
          <td style={cellStyle}>{salaryBreakupData.otherAllowance * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>Statutory Bonus</td>
          <td style={cellStyle}>{salaryBreakupData.statutoryBonus}</td>
          <td style={cellStyle}>{salaryBreakupData.statutoryBonus * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>Total Gross Salary (A)</td>
          <td style={headerStyle}>{salaryBreakupData.totalGrossSalary}</td>
          <td style={headerStyle}>{salaryBreakupData.totalGrossSalary * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
        </tr>
        <tr>
          <td style={cellStyle}>Add: Employer PF @ 12% on basic</td>
          <td style={cellStyle}>{salaryBreakupData.addEmployerPF}</td>
          <td style={cellStyle}>{salaryBreakupData.addEmployerPF * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>Total CTC (B)</td>
          <td style={headerStyle}>{salaryBreakupData.totalCTC}</td>
          <td style={headerStyle}>{salaryBreakupData.totalCTC * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
        </tr>
        <tr>
          <td style={headerStyle}>Deductions</td>
          <td style={cellStyle}></td>
          <td style={cellStyle}></td>
        </tr>
        <tr>
          <td style={cellStyle}>Employee PF @ 12% on basic</td>
          <td style={cellStyle}>{salaryBreakupData.employeePF}</td>
          <td style={cellStyle}> {salaryBreakupData.employeePF * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>Professional Tax</td>
          <td style={cellStyle}>{salaryBreakupData.professionalTax}</td>
          <td style={cellStyle}>{salaryBreakupData.professionalTax * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>Total Deductions (C)</td>
          <td style={headerStyle}>{salaryBreakupData.totalDeductions}</td>
          <td style={headerStyle}>{salaryBreakupData.totalDeductions * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
        </tr>
        <tr>
          <td style={headerStyle}>NET SALARY (A-C)</td>
          <td style={headerStyle}>
            {salaryBreakupData.totalGrossSalary -
              salaryBreakupData.totalDeductions}
          </td>
          <td style={headerStyle}>
            {salaryBreakupData.totalGrossSalary * 12 -
              salaryBreakupData.totalDeductions * 12}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

function OfferDetailsTemplateContract() {
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const history = useHistory();
  const location = useLocation();
  const agreementfileRef = useRef(null);
  const candidateId = new URLSearchParams(location.search).get("id");
  const [modalOpen, setModalOpen] = useState(false);
  const [hideActionBtns, setHideActionBtns] = useState(false);
  const [signData, setSignData] = useState({
    employeeName: "",
    companyName: "",
    designation: "",
    offerDate: "",
    probationPeriod: 0,
    joiningDate: "",
    address: "",
    apartment: "",
    city: "",
    postalCode: "",
    state: "",
  });
  const [salaryBreakupData, setSalaryBreakupData] = useState({
    basic: 0,
    hra: 0,
    otherAllowance: 0,
    statutoryBonus: 0,
    shiftAllowance: 0,
    addEmployerPF: 0,
    addESI: 0,
    gratuity: 0,
    employeeESI: 0,
    employeePF: 0,
    professionalTax: 0,
    totalDeductions: 0,
    totalCTC: 0,
    totalGrossSalary: 0,
  });

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MuiAvatar: {
          root: {
            fontFamily: '"Satoshi"',
          },
        },
        MuiMenuItem: {
          root: {
            fontFamily: '"Satoshi"',
          },
        },
        MUIDataTableToolbar: {
          actions: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          },
          icon: {
            color: "#064be2",
            "& svg": {
              color: "white",
              width: "25px",
              cursor: "pointer",
              height: "25px",
              padding: "5px",
              boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3)",
              borderRadius: "100%",
              backgroundColor: "#064be2",
            },
          },

          iconActive: {
            color: "#064be2",
            "& svg": {
              color: "white",
              width: "25px",
              cursor: "pointer",
              height: "25px",
              padding: "5px",
              boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3)",
              borderRadius: "100%",
              backgroundColor: "#064be2",
            },
          },
        },
        MUIDataTableBody: {
          emptyTitle: {
            "@media (max-width: 425px)": {
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            },
            "@media (max-width: 959.95px)": {
              marginLeft: "-100px",
            },
          },
        },

        MUIDataTableBodyCell: {
          stackedCommon: {
            "@media (max-width:959.95px)": {
              fontSize: "13px !important",
              "&:nth-last-child(2)": { fontWeight: 700 },
              "&:last-child": { lineBreak: "anywhere" },
            },
          },
          responsiveStackedSmallParent: {
            "@media (max-width:425px)": { width: "93%" },
          },
        },
        MuiTable: {
          root: {
            "& caption": { fontFamily: '"Satoshi" !important' },
          },
        },
        MuiBadge: {
          badge: {
            height: "30px!important",
            fontFamily: '"Satoshi" !important',
          },
          colorSecondary: {
            backgroundColor: red[500] + "!important",
          },
          anchorOriginTopLeftCircular: {
            top: "14%",
            left: "-21px",
            inlineSize: "max-content",
          },
        },
        MuiTableCell: {
          head: {
            color: "#121224",
            backgroundColor: "#f0f5f9 !important",
            fontSize: "15px !important",
            fontWeight: "bold",
            letterSpacing: "0.02em",
          },
          body: {
            color: "#121224",
            fontFamily: '"Satoshi" !important',
            fontSize: "13.5px !important",
            "&:last-child": { whiteSpace: "nowrap" },
          },

          root: {
            padding: "14px",
            fontFamily: '"Satoshi" !important',
          },
          paddingCheckbox: {
            "@media (max-width:959.95px)": { width: "10px" },
          },
        },
        MuiList: {
          padding: {
            paddingBottom: "0px !important",
          },
        },
        MuiListItem: {
          secondaryAction: {
            paddingRight: "45px !important",
          },
        },
        MuiSelect: {
          select: {
            "&:focus": { backgroundColor: "none !important" },
          },
        },

        MuiTableRow: {
          root: {
            "&:nth-of-type(odd)": { backgroundColor: "white" },
            "&:nth-of-type(even)": { backgroundColor: "#f0f5f9" },
          },
        },

        MuiIconButton: {
          root: {
            padding: "9px",
          },
        },

        MuiTypography: {
          subtitle1: {
            fontSize: "1rem",
            fontWeight: "500",
            fontFamily: '"Satoshi" !important',
            "@media (max-width:959.95px)": { fontSize: "0.9rem !important" },
          },
          subtitle2: {
            fontWeight: "500",
            fontFamily: '"Satoshi" !important',
            textAlign: "center",
            padding: "10px",
            fontSize: "21px",
            "@media (max-width:959.95px)": {
              fontSize: "calc(1.1rem) !important",
            },
          },
          body1: {
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": { fontSize: "13px !important" },
          },
          body2: {
            color: "#121224",
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": { fontSize: "13px !important" },
          },
          h5: {
            color: "#121224",
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": {
              fontSize: "calc(1.1rem) !important",
            },
          },
          h6: {
            color: "#121224",
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": {
              fontSize: "calc(1.1rem) !important",
            },
          },
        },
        MuiPaper: {
          elevation4: {
            boxShadow: "none",
          },
        },

        MuiDialog: {
          paper: {
            margin: "15px !important",
            border: "1px solid #000 !important",
          },
        },

        MuiFab: {
          root: {
            "&:hover": {
              backgroundColor: "064be2 !important",
            },
          },
        },
        MuiButton: {
          root: {
            fontFamily: '"Satoshi !important"',
            fontSize: "14px",
            fontWeight: 500,
            boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3) !important",
            "@media (max-width:959.95px)": { fontSize: "10px !important" },
          },
          label: {
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": { fontSize: "10px !important" },
          },
          containedPrimary: {
            backgroundColor: "#064be2 !important",
            textTransform: "initial !important",
            "&:active": {
              backgroundColor: "#064be2 !important",
              color: "#fff !important",
            },
            "&:hover": {
              backgroundColor: "#064be2 !important",
              color: "#fff !important",
            },
            "&:disabled": {
              backgroundColor: "#064be2c7 !important",
              color: "#fff !important",
            },
          },
          containedSizeSmall: {
            textTransform: "initial !important",
            padding: "4px 10px !important",
            fontWeight: "300 !important",
            height: "fit-content !important",
          },
          containedSecondary: {
            backgroundColor: red[500] + "!important",
            "&:active": {
              backgroundColor: red[500] + "!important",
              color: "#fff !important",
            },
            "&:hover": {
              backgroundColor: red[500] + "!important",
              color: "#fff !important",
            },
          },
        },
        MuiFormLabel: {
          root: {
            fontFamily: '"Satoshi" !important',
            fontSize: "20px",
            "@media (max-width:959.95px)": { fontSize: "15px !important" },
            color: "rgba(0, 0, 0, 0.87)",
          },
        },
        MuiCheckbox: {
          root: {
            color: "#bcbdbf",
          },
        },
        MuiFormControl: {
          root: {
            width: "100%",
          },
        },
        MuiTooltip: {
          tooltip: {
            fontFamily: '"Satoshi" !important',
          },
          // popper:{
          //   top: "-34px !important",
          //   left: '-45px !important'
          // }
        },
        MuiInputBase: {
          root: {
            width: "100%",
          },
          input: {
            width: "100%",
            border: "none",
            fontSize: "13px",
            display: "block",
            padding: "10px 12px !important",

            borderRadius: "4px",
          },
        },

        MuiAutocomplete: {
          input: {
            width: "100% !important",
          },
        },

        MuiFilledInput: {
          root: {
            width: "100%",
            display: "block",
            padding: "0px 25px 0px 0px !important",
            position: "relative",
            fontSize: "13px",
            marginTop: "24px",

            backgroundColor: "white",
            "&:hover": { backgroundColor: "unset !important" },
            "&.Mui-focused": { backgroundColor: "unset !important" },
          },

          underline: {
            "&&&:before": { borderBottom: "none" },
            "&&:after": { borderBottom: "none" },
          },
          inputAdornedEnd: {
            border: "1px solid #ced4da",
          },
        },

        MuiOutlined: {
          MuiChip: {
            avatar: { margin: "0px" },
          },
        },

        MuiCardContent: {
          root: {
            marginBottom: "10px !important",
            "&:last-child": { paddingBottom: "0px" },
          },
        },
        MuiDrawer: {
          paperAnchorBottom: {
            width: "50%",
            left: "30%",
            bottom: "10%",
          },
          paper: {
            overflowY: "auto",
            overflowX: "hidden",
          },
        },
        MuiDialogTitle: {
          root: {
            padding: "0px 10px !important",
          },
        },

        MuiChip: {
          avatar: {
            width: "50px !important",
            height: "50px !important",
            fontSize: "1.5rem !important",
            margin: "0px",
          },
        },
        MuiInputLabel: {
          shrink: {
            width: "max-content",
            display: "initial !important",
            transformOrigin: "top left !important",
            fontSize: "16px",
          },
        },
      },

      MuiFormGroup: {
        row: {
          marginTop: "10px !important",
        },
      },
    });

  const validationSchema = Yup.object().shape({
    employeeName: Yup.string()
      .max(255)
      .required("Employee Name is required")
      .max(255)
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Name Must be Alphanumeric",
      }),
    companyName: Yup.string().required("Company Name is required"),
    designation: Yup.string().required("Designation is required"),
    offerDate: Yup.string().required("Offer Date is required"),
    probationPeriod: Yup.number().required(
      "Probation Period field is required",
    ),
    joiningDate: Yup.string().required(
      "Expected Joining Date field is required",
    ),
    basic: Yup.number()
      .min(0, "Basic pay must be a number")
      .required("Basic pay is required"),
    otherAllowance: Yup.number()
      .min(0, "Other Allowance must be a number")
      .required("Other Allowance is required"),
    shiftAllowance: Yup.number()
      .min(0, "Shift Allowance must be a number")
      .required("Shift Allowance is required"),
    professionalTax: Yup.number()
      .min(0, "Professional Tax must be a number")
      .required("Professional Tax is required"),
    address: Yup.string().required("Address is required"),
    apartment: Yup.string().nullable().notRequired(),
    city: Yup.string().required("City name is required"),
    postalCode: Yup.string().required("ZIP/postal code is required"),
    state: Yup.string().required("State/province is required"),
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      basic: 0,
      otherAllowance: 0,
      shiftAllowance: 0,
      professionalTax: 0,
    },
  });

  var [errorToastId, setErrorToastId] = useState(null);
  var [notificationsPosition] = useState(2);

  const theme = useTheme();
  const classes = useStyles();
  const isMatch = useMediaQuery(theme.breakpoints.down("sm"));

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;
    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const styles = {
    grandMasterContainer: {
      minWidth: "800px",
      minHeight: "1000px",
      margin: "auto",
      maxWidth: "800px",
    },
    masterContainer: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "40px auto",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
      // filter: "blur(0px)",
    },
    masterContainerTwo: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "60px auto",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
      // filter: "blur(0px)",
    },
    masterContainerThree: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "120px auto 80px",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
    masterContainerFour: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "100px auto 0px",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
  };

  function handleAddAgreement(values) {
    setSignData({ ...values });

    try {
      if (imageSrc) {
        let HRA = values.basic / 2;
        let stautoryBonus = Math.round(values.basic / 12);

        let totalGrossSalary =
          values.basic + HRA + values.otherAllowance + stautoryBonus;

        let addEmployerPF = Math.round(values.basic * 0.12);
        let totalCTC = totalGrossSalary + addEmployerPF;

        let employeePF = Math.round(values.basic * 0.12);
        let totalDeductions = employeePF + values.professionalTax;

        setSalaryBreakupData({
          basic: values.basic,
          hra: HRA,
          otherAllowance: values.otherAllowance,
          statutoryBonus: stautoryBonus,
          shiftAllowance: 0,
          addEmployerPF: addEmployerPF,
          addESI: 0,
          gratuity: 0,
          employeeESI: 0,
          employeePF: employeePF,
          professionalTax: values.professionalTax,

          totalGrossSalary: totalGrossSalary,
          totalCTC: totalCTC,
          totalDeductions: totalDeductions,
        });
        console.log(values);
        handleModalClose();
        // setCandidateRoleModal(false);
        // setCandidateDetails({ ...values });
      } else {
        handleNotificationCall("info", "Please select signature");
      }
    } catch (error) {
      console.log(error);
    }
  }

  const [loader, setLoader] = useState(false);

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImgae, setCroppedImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const currentTodayDate = moment(new Date()).format("DD");
  const currentTodayMonth = moment(new Date()).format("MMMM");
  const currentTodayyear = moment(new Date()).format("YYYY");

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file && file?.size >= 2000000) {
        handleNotificationCall("info", "Maximum File Size Limit 2mb");
        return;
      }
      const reader = new FileReader();
      reader.addEventListener("load", () => setImageSrc(reader.result));
      reader.readAsDataURL(file);
      setShowModal(true);
    }
  };

  const onCropComplete = useCallback(
    async (croppedArea, croppedAreaPixels) => {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedAreaPixels(croppedAreaPixels);
      const reader = new FileReader();
      reader.readAsDataURL(croppedImageBlob);
      reader.onloadend = () => {
        setCroppedImage(reader.result); // This will be a base64 data URL
      };
    },
    [imageSrc],
  );

  const handleUpload = async () => {
    if (!croppedAreaPixels || !imageSrc) return;
    const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

    if (croppedImageBlob.size > 3 * 1024 * 1024) {
      alert("The cropped image size exceeds 3MB. Please crop again.");
      return;
    }
    setShowModal(false);
  };

  const handleGeneratePdf = async () => {
    setHideActionBtns(true);
    // if (!croppedImgae) {
    //   handleNotificationCall("info", " please Attach your Signature");
    //   setHideActionBtns(false);
    //   return;
    // }
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
      compress: true,
      lineHeight: 1.2,
    });

    doc.addFont(InterFont, "Inter", "normal");
    doc.setFont("Inter");
    const element = agreementfileRef.current;
    if (element) {
      await doc.html(element, {
        callback: (doc) => {
          const pdfBlob = doc.output("blob");
          handleAgreementSign(pdfBlob, doc);
          // doc.save(`non-disclosure_agreement${Date.now()}.pdf`);
        },
        x: 10,
        y: 10,
        html2canvas: {
          scale: 0.7, // Adjust the scale for better quality
          logging: true, // Enable logging for debugging
          useCORS: true,
          letterRendering: false,
        },
        windowWidth: 800,
      });
    }
  };

  const handleClearFormData = () => {
    reset();
    setImageSrc(null);
    setCroppedImage(null);
    handleModalOpen();
  };

  async function handleAgreementSign(pdfBlob, doc) {
    setLoader(true);
    const formData = new FormData();
    const nonDisclosureFile = new File(
      [pdfBlob],
      `offer_letter_shared_${Date.now()}.pdf`,
    );
    formData.append("document", nonDisclosureFile);
    formData.append("sendMessage", false);
    formData.append("candidateId", candidateId);
    formData.append("phone_number", "");
    formData.append("template_name", "offer_detailed_confirmation");
    formData.append("message", "message");

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/changeAndSendOfferDetail`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);
        handleNotificationCall("success", response.data.message);
        doc.save(`offer_letter_shared_${candidateId}_${Date.now()}.pdf`);
        if (decode.role === "ADMIN") {
          history.push("/app/admin_candidates");
        } else {
          history.push("/app/dashboard");
        }
      } else {
        setLoader(false);
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  useEffect(() => {
    if (candidateId) {
      setModalOpen(true);
    }
  }, []);

  return (
    <div className={classes.backgroundColor}>
      <MuiThemeProvider theme={getMuiTheme()}>
        <>
          <AppBar className={classes.appBarBg}>
            <Toolbar className={classes.toolbarLP}>
              {isMatch ? (
                <>
                  <div className={classes.refoTitleMobile}>
                    <p className="refo-name">refo</p>
                  </div>
                  <div className={classes.flexCenter} style={{ width: "100%" }}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </div>
                  {/* <DrawerComp /> */}
                </>
              ) : (
                <Grid className={classes.gridCenter} container spacing={2}>
                  <Grid item xs={1} md={1} className={classes.refoTitle}>
                    <p className="refo-name">refo</p>
                  </Grid>
                  <Grid item xs={11} md={11} className={classes.flexCenter}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </Grid>
                </Grid>
              )}
            </Toolbar>
          </AppBar>

          <div style={{ marginTop: "5rem", overflow: "auto" }}>
            <div ref={agreementfileRef} style={styles.grandMasterContainer}>
              <div style={styles.masterContainer}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <td style={{ textAlign: "center", margin: "0" }}>
                        <img
                          src={loanSolvLogo}
                          width="300"
                          alt="logo_company"
                          style={{ display: "block", margin: " 0 auto" }}
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "end",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "10px 0",
                        }}
                      >
                        <p>
                          Date:{" "}
                          {moment(signData.offerDate).format("Do MMMM YY")}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p style={{ margin: "8px 0px" }}>
                          Mr/Ms. {signData.employeeName}
                        </p>
                        <p style={{ margin: "8px 0px" }}>{signData.address},</p>
                        <p style={{ margin: "8px 0px" }}>
                          {signData.apartment},
                        </p>
                        <p style={{ margin: "8px 0px" }}>
                          {signData.city} - {signData.postalCode},
                        </p>
                        <p style={{ margin: "8px 0px" }}>{signData.state}.</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p>Dear {signData.employeeName},</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p>
                          <b>Sub: Offer for employment</b>
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        <p>
                          With reference to the discussions we had and
                          subsequent to the client interview you had, we wish to
                          inform that you have successfully completed the
                          selection process and we are pleased to offer you
                          employment in our organization as{" "}
                          <b>{signData.designation}</b> for a fixed period of
                          Six months, on the following terms and conditions:
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          <ol
                            style={{
                              marginTop: "0",
                              paddingLeft: "20px",
                              listStylePosition: "outside",
                            }}
                          >
                            <li style={{ paddingLeft: "16px" }}>
                              You will be paid annual CTC of Rs.{" "}
                              {salaryBreakupData.totalGrossSalary -
                                salaryBreakupData.totalDeductions}
                              /- only as per the breakup attached.
                              <br />
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You will be joining the client organization on or
                              before{" "}
                              {moment(signData.joiningDate).format(
                                "Do MMMM YYYY",
                              )}
                              .
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You will be working at our client site M/s{" "}
                              {signData.companyName} Pvt Ltd., Client Office
                              Address, representing Company Name. (hereinafter
                              referred to as Company Name).
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              In the event of project / work for which you are
                              being employed comes to an end as decided by the
                              client to whom you are being deputed for work,
                              this contract shall be co-terminus with the
                              mentioned project / work.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You will be informed about the working conditions,
                              project requirement, etc., by the client and you
                              will be required to adhere to the same.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You will adhere to the general rules and
                              regulations, working hours, etc. as per the
                              guidelines given by the Client.
                            </li>
                          </ol>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={styles.masterContainerTwo}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <td style={{ textAlign: "center", margin: "0" }}>
                        <img
                          src={loanSolvLogo}
                          width="300"
                          alt="logo_company"
                          style={{ display: "block", margin: " 0 auto" }}
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          <ol
                            start={7}
                            style={{
                              marginTop: "0",
                              paddingLeft: "20px",
                              listStylePosition: "outside",
                            }}
                          >
                            <li style={{ paddingLeft: "16px" }}>
                              If there is any change in time, location and plan
                              in project, the same shall be informed by the
                              Client in advance and you shall adhere to the
                              same.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You will be entitled for two days leave per month
                              and availing leave is subject to the Client’s
                              approval. Any leave taken beyond the approved
                              leave shall be treated as loss of pay.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              If you have to travel overseas on a project, then
                              the Client will pay all the expenses pertaining to
                              the travel directly to you as per your
                              eligibility.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              Non-disclosure : In the performance of this
                              Agreement, either party may disclose to the other
                              certain trade secrets and other information that
                              is of value to its owner and is treated as
                              confidential (collectively, “Confidential
                              Information”). Both the parties acknowledge and
                              agree that the Confidential Information shall
                              remain the sole and exclusive property of the
                              disclosing party or a third party providing such
                              information to the disclosing party. The receiving
                              party agrees to hold the Confidential Information
                              disclosed by the other party in strictest
                              confidence and not to, directly or indirectly,
                              copy, use, reproduce, distribute, manufacture,
                              duplicate, reveal, report, publish, disclose,
                              cause to be disclosed, or otherwise transfer the
                              Confidential Information for any purpose
                              whatsoever other than as expressly provided by
                              this Agreement. Subject to the terms set forth
                              herein, the receiving party shall not disclose the
                              Confidential Information to a third party without
                              the written consent of the disclosing party and
                              shall protect the Confidential Information of the
                              disclosing party with the same degree of
                              protection and care the receiving party uses to
                              protect its own Confidential Information, but in
                              no event less than reasonable care. With regard to
                              Confidential Information constituting a trade
                              secret, the obligations in this section shall
                              continue for so long as such information
                              constitutes a trade secret under applicable law.
                              With regard to all other Confidential Information,
                              the obligations in this Section shall continue for
                              the term of this Agreement and for a period of
                              five years thereafter.
                            </li>

                            <li style={{ paddingLeft: "16px" }}>
                              Either party may terminate this Agreement at any
                              time upon 60 days written notice or salary in lieu
                              thereof. However, the management discretion is
                              final. if the performance or conduct of the
                              Consultant is not in line with the Client’s
                              organization standard, then your services may be
                              terminated immediately.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You shall at no point of time stake any claim or
                              right to claim employment, damage, loss or
                              compensation of any sort whatsoever against the
                              Client Organization.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              Your salary will be credited to your bank account
                              on or before 5th of every month.
                            </li>
                          </ol>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={styles.masterContainerThree}>
                <thead>
                  <tr>
                    <td style={{ textAlign: "center", margin: "0" }}>
                      <img
                        src={loanSolvLogo}
                        width="300"
                        alt="logo_company"
                        style={{ display: "block", margin: " 0 auto" }}
                      />
                    </td>
                  </tr>
                </thead>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          <ol
                            start={12}
                            style={{
                              marginTop: "0",
                              paddingLeft: "20px",
                              listStylePosition: "outside",
                            }}
                          ></ol>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        <p>
                          Please sign the duplicate copy of this letter as a
                          token of your acceptance of the above terms and
                          conditions.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p style={{ margin: "8px 0px" }}>Best Wishes,</p>
                        <p style={{ margin: "8px 0px" }}>Yours truly,</p>
                        <p style={{ margin: "8px 0px" }}>
                          For {signData.companyName}.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                          fontSize: "11pt",
                          position: "relative",
                          height: "40px",
                        }}
                      >
                        <img
                          src={croppedImgae}
                          style={{
                            position: "absolute",
                            top: "0px",
                            left: "20px",
                            maxWidth: "160px",
                            height: "45px",
                            objectFit: "contain",
                          }}
                          alt="add_signature_here"
                        />
                        {!hideActionBtns && (
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              position: "absolute",
                              top: "6px",
                              left: "260px",
                            }}
                          >
                            <Tooltip
                              title="Remove sign"
                              placement="bottom"
                              aria-label="delete"
                            >
                              <DeleteIcon
                                className={classes.toolIconDelete}
                                onClick={(e) => {
                                  setCroppedImage(null);
                                }}
                              />
                            </Tooltip>
                            <Tooltip
                              title="Edit Details"
                              placement="bottom"
                              aria-label="delete"
                            >
                              <EditIcon
                                className={classes.toolIcon}
                                onClick={() => handleModalOpen()}
                                // onClick={() => document.getElementById("editFileInput")?.click()}
                              />
                            </Tooltip>
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                          fontSize: "11pt",
                        }}
                      >
                        <p style={{ margin: "20px 0 0" }}>
                          <b>Authorized Person Name</b> &nbsp;{" "}
                          {"Balaji Ramaswamy,"}{" "}
                        </p>
                        <p style={{ margin: "0 0 60px" }}>
                          <b>Designation</b> &nbsp; {"Director"}
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        <p>I Accept the above terms of employment.</p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                          fontSize: "11pt",
                          position: "relative",
                        }}
                      >
                        <p style={{ display: "flex" }}>
                          My date of joining will be{" "}
                          <span
                            style={{
                              width: "200px",
                              display: "block",
                              borderBottom: "1px solid #000",
                              marginLeft: "10px",
                              padding: "0 10px",
                            }}
                          ></span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                          fontSize: "11pt",
                          position: "relative",
                        }}
                      >
                        EMPLOYEE NAME <br />
                        (signature)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={styles.masterContainerFour}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <td style={{ textAlign: "center", margin: "0" }}>
                        <img
                          src={loanSolvLogo}
                          width="300"
                          alt="logo_company"
                          style={{ display: "block", margin: " 0 auto" }}
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <SalaryTable
                          signData={signData}
                          salaryBreakupData={salaryBreakupData}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p style={{ padding: "0px 15px" }}>
                          <b>
                            $$ Group Mediclaim for the employee will be provided
                            for 2 lakhs coverage Income Tax will be applicable
                            as per IT Act
                          </b>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                margin: "0px 20px 20px 20px",
              }}
            >
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleClearFormData}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                size="small"
                color="primary"
                className={classes.green}
                onClick={handleGeneratePdf}
              >
                Send
              </Button>
            </div>
          </div>

          <Dialog
            aria-labelledby="dialog-title"
            open={modalOpen}
            width="md"
            maxWidth="sm"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
          >
            <DialogContent className={classes.center}>
              <Grid
                container
                direction="row"
                spacing={2}
                style={{ padding: "10px" }}
              >
                <div
                  className={classes.heading + " " + classes.inputRoot}
                ></div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    width: "100%",
                  }}
                >
                  <form onSubmit={handleSubmit(handleAddAgreement)}>
                    <Grid
                      container
                      direction="row"
                      spacing={2}
                      style={{ paddingTop: "60px" }}
                    >
                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="employeeName">
                          Employee Name
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your EmployeeName"
                            id="employeeName"
                            error={errors.employeeName ? true : false}
                            {...register("employeeName")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.employeeName?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <InputLabel shrink htmlFor="designation">
                          Designation
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            placeholder="Enter Designation Name"
                            {...register("designation")}
                            error={errors.designation ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.designation?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <InputLabel shrink htmlFor="offerDate">
                          Offer Date
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            type="date"
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            placeholder="Enter Date"
                            {...register("offerDate")}
                            error={errors.offerDate ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.offerDate?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <InputLabel shrink htmlFor="companyName">
                          Company Name
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            placeholder="Enter Company Name"
                            {...register("companyName")}
                            error={errors.companyName ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.companyName?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="address">
                          Address
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your Address Name"
                            id="address"
                            error={errors.address ? true : false}
                            {...register("address")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.address?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="apartment">
                          Apartment, suite, etc.
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Apartment, suite, etc. "
                            id="apartment"
                            error={errors.apartment ? true : false}
                            {...register("apartment")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.apartment?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="city">
                          City
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your City Name"
                            id="city"
                            error={errors.city ? true : false}
                            {...register("city")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.city?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="postalCode">
                          ZIP/postal code
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your ZIP/postal code"
                            id="postalCode"
                            error={errors.postalCode ? true : false}
                            {...register("postalCode")}
                            autoComplete="postal-code"
                          />

                          <Typography variant="inherit" color="error">
                            {errors.postalCode?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="state">
                          State/province
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your State/province Name"
                            id="state"
                            error={errors.state ? true : false}
                            {...register("state")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.state?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <InputLabel shrink htmlFor="probationPeriod">
                          Probation Period in month
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            type="number"
                            InputProps={{
                              disableUnderline: true,
                            }}
                            classes={{ root: classes.customTextField }}
                            placeholder="Enter Probation Period in month"
                            {...register("probationPeriod")}
                            error={errors.probationPeriod ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.probationPeriod?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <InputLabel shrink htmlFor="joiningDate">
                          Expected Joining Date
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            type="date"
                            InputProps={{
                              disableUnderline: true,
                            }}
                            classes={{ root: classes.customTextField }}
                            placeholder="Enter Expected Joining Date"
                            {...register("joiningDate")}
                            error={errors.joiningDate ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.joiningDate?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <InputLabel shrink htmlFor="basic">
                          Basic pay per month
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            type="number"
                            InputProps={{
                              disableUnderline: true,
                              startAdornment: (
                                <InputAdornment position="end">
                                  <BsCurrencyRupee />
                                </InputAdornment>
                              ),
                            }}
                            classes={{ root: classes.customTextField }}
                            placeholder="Enter Basic Pay"
                            {...register("basic")}
                            error={errors.basic ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.basic?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <InputLabel shrink htmlFor="otherAllowance">
                          Other Allowance per month
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            type="number"
                            InputProps={{
                              disableUnderline: true,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <BsCurrencyRupee />
                                </InputAdornment>
                              ),
                            }}
                            classes={{ root: classes.customTextField }}
                            placeholder="Enter Other Allowance"
                            {...register("otherAllowance")}
                            error={errors.otherAllowance ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.otherAllowance?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <InputLabel shrink htmlFor="professionalTax">
                          Professional Tax
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            type="number"
                            InputProps={{
                              disableUnderline: true,
                              startAdornment: (
                                <InputAdornment position="end">
                                  <BsCurrencyRupee />
                                </InputAdornment>
                              ),
                            }}
                            classes={{ root: classes.customTextField }}
                            placeholder="Enter Professional Tax"
                            {...register("professionalTax")}
                            error={errors.professionalTax ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.professionalTax?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="signature">
                          Signature
                        </InputLabel>

                        <FormControl className={classes.margin}>
                          <div
                            className={
                              classes.space + " " + classes.alignItemsEnd
                            }
                          >
                            <div className={classes.marginTop}>
                              <input
                                accept=".jpg,.jpeg,.png"
                                className={classes.input}
                                id="fileInput"
                                type="file"
                                style={{ display: "none", height: "100%" }}
                                onChange={handleFileChange}
                              />
                              <label
                                htmlFor="icon-button-profile"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <Button
                                  type="button"
                                  variant="contained"
                                  className={classes.button}
                                  color="primary"
                                  aria-label="upload signature"
                                  onClick={() =>
                                    document
                                      .getElementById("fileInput")
                                      ?.click()
                                  }
                                >
                                  Signature
                                </Button>
                                {croppedImgae && (
                                  <CheckCircleIcon
                                    style={{ color: "#06D001" }}
                                  />
                                )}
                              </label>
                            </div>
                          </div>
                        </FormControl>

                        <Typography variant="inherit" color="error">
                          {errors.files?.message}
                        </Typography>
                      </Grid>
                    </Grid>
                    <div
                      style={{
                        margin: "10px 15px",
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="small"
                        className={classes.green}
                      >
                        Submit
                      </Button>
                    </div>
                  </form>
                </div>
              </Grid>
            </DialogContent>
          </Dialog>

          <Dialog
            aria-labelledby="dialog-title"
            open={showModal}
            width="md"
            maxWidth="sm"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
            onClose={() => setShowModal(false)}
          >
            <DialogContent>
              <div
                className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
              >
                <Typography variant="subtitle2" className={classes.inputRoot}>
                  {" "}
                  Crop Image{" "}
                </Typography>

                <div className={classes.pdfModalCloseBtn}>
                  <CloseIcon className={classes.closeBtn} />
                </div>
              </div>
              <div
                className="d-flex"
                style={{ position: "sticky", minHeight: "50vh" }}
              >
                {imageSrc && (
                  <div className="crop-container">
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={16 / 9}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                )}
              </div>
              <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={() => {
                    setShowModal(false);
                    setCroppedImage(null);
                    setImageSrc(null);
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleUpload}
                >
                  Crop
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          <ToastContainer
            closeButton={
              <CloseButton className={classes.notificationCloseButton} />
            }
            closeOnClick={false}
            hideProgressBar={true}
          />
          <Backdrop className={classes.backdrop} open={loader}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      </MuiThemeProvider>
    </div>
  );
}

export default OfferDetailsTemplateContract;
function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}
